// Sentinel `stripeMetadata.chargeId` values that mean an order's payment has
// not settled yet (async bank-based methods that clear out-of-band). Once the
// funds are reconciled the chargeId is rewritten to the real Stripe charge id
// (or `eft_manual_confirmed`), so any value in this list reliably indicates a
// still-pending payment.
//
// `"pending"` is the generic placeholder used when a renewable-purchase order
// is materialized before payment settles (e.g. a membership renewal paid by
// bank transfer). Without it, those orders incorrectly render as fully paid.
export const EFT_PENDING_CHARGE_IDS = [
  "eft_bank_transfer",
  "acss_pending",
  "ach_pending",
  "bank_transfer_pending",
  "pending",
] as const;

/** Booking request that hasn't been approved or declined yet. */
export const APPROVAL_PENDING_CHARGE_ID = "approval_pending";
/**
 * Approved booking request whose invoice hasn't been paid. Payment is recorded
 * on the invoice, never on the order.
 */
export const DEFERRED_PENDING_CHARGE_ID = "deferred_pending";

export const isEftPendingChargeId = (
  chargeId: string | null | undefined,
): boolean => EFT_PENDING_CHARGE_IDS.includes((chargeId ?? "") as never);

export const isAchPendingChargeId = (
  chargeId: string | null | undefined,
): boolean => chargeId === "ach_pending" || chargeId === "acss_pending";

/** Offline / admin-confirmed settlements that should render as paid. */
export const MANUALLY_CONFIRMED_PAID_CHARGE_IDS = [
  "eft_manual_confirmed",
  "offline",
  "free_order",
] as const;

export const isManuallyConfirmedPaidChargeId = (
  chargeId: string | null | undefined,
): boolean =>
  MANUALLY_CONFIRMED_PAID_CHARGE_IDS.includes((chargeId ?? "") as never);
